import { type ISelectionStrategy } from './abstract.selection.strategy';

export class DefaultSingleSelectionStrategy implements ISelectionStrategy {
    constructor(private selection) {}

    public update(items) {
        if (this.selection && this.selection.single && this.selection.size === 0 && items.length) {
            this.selection.toggle(items[0]);
        }
    }
}
